import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import * as api from '../api/api';
import { pickErrorMessage } from '../lib/apiHelpers';
import { PageHeader, Card, CardBody, ErrorBanner, BackLink } from '../components/PageChrome';
import { MetadataEditor, cleanMetadata } from '../components/MetadataEditor';

export default function CouponForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [metadata, setMetadata] = useState([{ label: '', value: '' }]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const row = await api.getCoupon(id);
        if (!cancelled) {
          setCode(row.code || '');
          setMetadata(row.metadata?.length ? row.metadata : [{ label: '', value: '' }]);
        }
      } catch (e) {
        if (!cancelled) setError(pickErrorMessage(e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [id]);

  async function handleSubmit(e) {
    e.preventDefault();
    const cleaned = cleanMetadata(metadata);
    if (!cleaned.length) {
      setError('Add at least one metadata label and value.');
      return;
    }
    setBusy(true);
    setError('');
    try {
      await api.updateCoupon(id, { metadata: cleaned });
      navigate('/coupons');
    } catch (err) {
      setError(pickErrorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  if (loading) {
    return <div className="d-flex justify-content-center py-5"><div className="spinner-border text-primary" role="status" /></div>;
  }

  return (
    <>
      <BackLink to="/coupons">Coupons</BackLink>
      <PageHeader title="Edit coupon" subtitle={code ? `Code: ${code}` : ''} />
      <ErrorBanner message={error} />
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit} className="mw-form">
            <MetadataEditor items={metadata} onChange={setMetadata} />
            <div className="d-flex gap-2 mt-4">
              <button type="submit" className="btn btn-primary" disabled={busy}>{busy ? 'Saving…' : 'Save'}</button>
              <Link to="/coupons" className="btn btn-outline-secondary">Cancel</Link>
            </div>
          </form>
        </CardBody>
      </Card>
    </>
  );
}
